import { StatusService } from './../../services/authentication/status.service';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {
  @Input() title = 'carregando';
  statusService: StatusService;

  constructor(statusService: StatusService) {
    this.statusService = statusService;
  }
}
